<template>
  <v-card class="card" :class="{ shadow: !flat }" :flat="flat">
    <component
      :is="`v-card-${part}`"
      v-for="part in parts"
      :key="part"
      :class="part"
    >
      <slot :name="part" />
    </component>
  </v-card>
</template>

<script>
export default {
  name: 'SsoCard',
  props: {
    flat: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    parts() {
      return ['title', 'text', 'actions'].filter((part) => this.$slots[part]?.());
    },
  },
};
</script>

<style scoped lang="less">
.card {
  border-radius: 10px;
  border-color: @text-darkest;
  padding: 16px;
}
.title {
  border-bottom: solid 1px fade(@grey-900, 5%);
}
.actions {
  border-top: solid 1px fade(@grey-900, 5%);
}
</style>
